module.exports = __webpack_public_path__ + "img/img_1.0e0bb67.webp";